import { render, staticRenderFns } from "./DataViewSidebarCategories.vue?vue&type=template&id=f09eb976&scoped=true&"
import script from "./DataViewSidebarCategories.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarCategories.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarCategories.vue?vue&type=style&index=0&id=f09eb976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09eb976",
  null
  
)

export default component.exports